import { isEmpty } from 'lodash/fp';

const checkForNewWindowLabels = (windowObj, label, itemId) => {
  if (!isEmpty(windowObj)) {
    const findMatchingIdsandFilter = windowObj.payload.filter(obj => obj.itemId === itemId);
    if (findMatchingIdsandFilter.length > 0) {
      const newLabel = findMatchingIdsandFilter.map(item => item.newLabel);
      return newLabel;
    }
  }
  return label;
};

export default checkForNewWindowLabels;
